"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorCodes = exports.errorNames = exports.INTERNAL_SERVER_ERROR = exports.BAD_REQUEST = exports.NOT_FOUND = exports.FORBIDDEN = exports.UNAUTHORIZED = void 0;
const http_status_codes_1 = require("http-status-codes");
exports.UNAUTHORIZED = http_status_codes_1.StatusCodes.UNAUTHORIZED, exports.FORBIDDEN = http_status_codes_1.StatusCodes.FORBIDDEN, exports.NOT_FOUND = http_status_codes_1.StatusCodes.NOT_FOUND, exports.BAD_REQUEST = http_status_codes_1.StatusCodes.BAD_REQUEST, exports.INTERNAL_SERVER_ERROR = http_status_codes_1.StatusCodes.INTERNAL_SERVER_ERROR;
exports.errorNames = {
    UNAUTHORIZED: 'Unauthorized',
    FORBIDDEN: 'Forbidden',
    NOT_FOUND: 'NotFound',
    BAD_REQUEST: 'BadRequest',
    INTERNAL_SERVER_ERROR: 'InternalServerError',
};
exports.errorCodes = {
    Unauthorized: exports.UNAUTHORIZED,
    Forbidden: exports.FORBIDDEN,
    NotFound: exports.NOT_FOUND,
    BadRequest: exports.BAD_REQUEST,
    InternalServerError: exports.INTERNAL_SERVER_ERROR,
};
